"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const moment_jalaali_1 = __importDefault(require("moment-jalaali"));
const assets_1 = require("../assets");
const styles_1 = require("../styles");
const constants_1 = require("../utility/constants");
const Text_1 = __importDefault(require("./Text"));
const BottomSheet_1 = __importDefault(require("./BottomSheet"));
const TextInput_1 = __importDefault(require("./TextInput"));
const Select_1 = __importDefault(require("./Select"));
const CalenderIcon_1 = __importDefault(require("../icons/CalenderIcon"));
const handleDays = (testID) => {
    const days = [react_1.default.createElement(Select_1.default.Item, { label: "\u0631\u0648\u0632", value: -1, key: 'day-1' })];
    let numberOfDays = 31;
    for (let day = 1; day <= numberOfDays; day++) {
        days.push(react_1.default.createElement(Select_1.default.Item, { testID: `dateInPicker${testID}${day}`, key: `day-${day}`, label: `\u200f${constants_1.daysValue[day - 1]}`, value: day }));
    }
    return days;
};
const handleMonths = (testID) => {
    const months = [react_1.default.createElement(Select_1.default.Item, { label: "\u0645\u0627\u0647", value: -1, key: 'month-1' })];
    for (let i = 1; i <= 12; i++) {
        months.push(react_1.default.createElement(Select_1.default.Item, { testID: `monthInPicker${testID}${i}`, key: `month-${i}`, label: constants_1.nameOfMonths[i - 1], value: i }));
    }
    return months;
};
const handleValue = (v) => {
    return parseInt(v.toString(), 10);
};
const DatePicker = ({ onConfirm, placeholder, value, label, disabled, margin = 'default', testID, toggleModal, after, before, sameOrBefore, sameOrAfter, format = 'jYYYY/jMM/jDD', displayFormat = 'jYYYY/jMM/jDD', style, variant = 'contained', }) => {
    const [modalVisibility, setModalVisibility] = react_1.useState(false);
    const [day, setDay] = react_1.useState(-1);
    const [month, setMonth] = react_1.useState(-1);
    const [year, setYear] = react_1.useState();
    const [error, setError] = react_1.useState(false);
    const [previosToggleModal, setPriviosToggleModal] = react_1.useState(toggleModal);
    react_1.useEffect(() => {
        if (toggleModal !== previosToggleModal) {
            setPriviosToggleModal(toggleModal);
            setModalVisibility(true);
        }
        if (value) {
            const momentDate = moment_jalaali_1.default.utc(value, format).startOf('day');
            setDay(momentDate.jDate());
            setMonth(momentDate.jMonth() + 1);
            setYear(momentDate.jYear().toString());
        }
    }, [toggleModal, previosToggleModal, value, format]);
    const handleYear = (y) => {
        setYear(y.replace(/\D/g, '').substring(0, 4));
    };
    const validateDate = () => {
        if (month < 0 || day < 0)
            return setError(true);
        const date = moment_jalaali_1.default.utc(`${year}/${month}/${day}`, displayFormat).startOf('day');
        const isAfter = after ? date.isAfter(after, 'day') : true;
        const isBefore = before ? date.isBefore(before, 'day') : true;
        const isSameOrBefore = sameOrBefore ? date.isSameOrBefore(sameOrBefore, 'day') : true;
        const isSameOrAfter = sameOrAfter ? date.isSameOrAfter(sameOrAfter, 'day') : true;
        if (date.isValid() && isAfter && isBefore && isSameOrAfter && isSameOrBefore) {
            onConfirm && onConfirm(date.format(format));
            setModalVisibility(false);
            setError(false);
        }
        else
            setError(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BottomSheet_1.default, { onRequestClose: () => {
                setModalVisibility(false);
            }, visible: modalVisibility },
            react_1.default.createElement(react_native_1.View, { style: styles.rowView },
                react_1.default.createElement(react_native_1.View, { style: { flex: 1 } }, error && react_1.default.createElement(Text_1.default, { color: 'error' }, "\u062A\u0627\u0631\u06CC\u062E \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0635\u062D\u06CC\u062D \u0646\u0645\u06CC\u200C\u0628\u0627\u0634\u062F.")),
                react_1.default.createElement(react_native_1.View, { style: styles.confirmView },
                    react_1.default.createElement(react_native_1.TouchableOpacity, { testID: `confirm${testID}`, onPress: () => {
                            validateDate();
                        } },
                        react_1.default.createElement(Text_1.default, { color: "primary" }, "\u062A\u0627\u06CC\u06CC\u062F")))),
            react_1.default.createElement(react_native_1.View, { style: styles.pickersView },
                react_1.default.createElement(Select_1.default, { testID: `pickerDate${testID}`, children: handleDays(testID), value: day, onValueChange: (selectedDate) => {
                        selectedDate !== -1 && setDay(handleValue(selectedDate));
                    }, style: {
                        width: '20%',
                    }, selectStyle: {
                        minWidth: '50%',
                        left: '-160%',
                    }, key: `day-${day}` }),
                react_1.default.createElement(Select_1.default, { testID: `pickerMonth${testID}`, children: handleMonths(testID), value: month, onValueChange: (selectedMonth) => {
                        selectedMonth !== -1 && setMonth(handleValue(selectedMonth));
                    }, style: {
                        width: '35%',
                    }, selectStyle: { minWidth: '100%', left: '-140%' }, key: `month-${month}` }),
                react_1.default.createElement(TextInput_1.default, { textInputStyle: { textAlign: 'right', width: '100%' }, value: year, onChangeText: (y) => handleYear(y), placeholder: "\u0633\u0627\u0644\u061B \u0645\u062B\u0627\u0644: 1357", style: styles.yearTextInput, keyboardType: "numeric" }))),
        react_1.default.createElement(react_native_1.TouchableOpacity, { testID: testID, disabled: disabled, style: react_native_1.StyleSheet.flatten([
                styles.container,
                variants[variant],
                disabled && styles.disabledInput,
                { marginBottom: margin === 'none' ? 0 : styles_1.getSpacing() },
                style,
            ]), onPress: () => {
                setModalVisibility(true);
            } },
            react_1.default.createElement(react_native_1.View, { style: styles.fieldView },
                react_1.default.createElement(react_native_1.View, { style: styles.textView }, value ? (react_1.default.createElement(Text_1.default, { margin: "none", style: styles.dateTextLabel, color: variant === 'outlined' ? 'description' : 'default' },
                    `${label}: `,
                    react_1.default.createElement(Text_1.default, { margin: "none", color: variant === 'outlined' ? 'default' : 'primary' }, moment_jalaali_1.default.utc(value, format).startOf('day').format(displayFormat)))) : (react_1.default.createElement(Text_1.default, { color: "disabled", margin: "none" }, placeholder))),
                react_1.default.createElement(CalenderIcon_1.default, { style: styles.icon })))));
};
exports.default = DatePicker;
const variants = react_native_1.StyleSheet.create({
    contained: {
        backgroundColor: styles_1.Colors.background,
    },
    outlined: {
        borderWidth: styles_1.getSpacing('border'),
        borderColor: styles_1.Colors.primary,
    },
});
const styles = react_native_1.StyleSheet.create({
    container: {
        borderRadius: assets_1.Shape.buttonBorderRadius,
        height: assets_1.Shape.rowHeight,
        justifyContent: 'center',
        marginBottom: styles_1.getSpacing(),
    },
    fieldView: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    icon: {
        height: 15,
        width: 15,
        marginRight: styles_1.getSpacing(),
    },
    textView: {
        marginLeft: styles_1.getSpacing(),
    },
    pickersView: {
        flexDirection: 'row',
    },
    dateTextLabel: {
        textAlign: 'left',
    },
    rowView: {
        flexDirection: 'row',
        marginHorizontal: styles_1.getSpacing(),
    },
    confirmView: {
        alignSelf: 'flex-end',
    },
    yearTextInput: {
        height: 37,
        flex: 2,
        textAlign: 'left',
    },
    disabledInput: {
        backgroundColor: styles_1.Colors.white,
        borderColor: styles_1.Colors.border,
        borderWidth: assets_1.Shape.borderWidth,
    },
});
